import { FC } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { MannKindLogo } from "../../assets";
import { PublicHeader } from "../../constants/headerLinks";
import { HeaderElementType } from "../../types";
import { FAX_NUMBER, PHONE_NUMBER } from "../../constants/contact";



const GuestHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();

  const closeMobileMenu = () => {
    const navbarCollapse = document.getElementById('hubHeader');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg py-1">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/users/sign_in">
            <img className="img-fluid" src={MannKindLogo} alt="Site logo" />
          </Link>
          <button className="navbar-toggler bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#hubHeader">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-start" id="hubHeader">
            <ul className="navbar-nav">
              {PublicHeader.map((headerLink, index) => (
                <li className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`} key={index}>
                  {headerLink.actionType === HeaderElementType.ROUTE ? (
                    <Link className="nav-link" aria-current="page" to={headerLink.redirectLink} onClick={closeMobileMenu}>{headerLink.title}</Link>
                  ) : null}
                  {headerLink.actionType === HeaderElementType.BUTTON ? (
                      <button className="btn upload-btn" onClick={() => {
                        closeMobileMenu();
                        navigate(headerLink.redirectLink);
                      }}>
                        {headerLink.title}
                      </button>
                  ) : null}
                  {headerLink.actionType === HeaderElementType.LINK ? (
                    <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
                      {headerLink.title}
                    </a>
                  ) : null}
                  {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                    <>
                      <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown" aria-expanded="false" >
                        {headerLink.title}
                      </a>
                      <ul className="resources-dropdown dropdown-menu dropdown-center" style={{ top: '53px' }}>
                        {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                          <li key={index}>
                            {headerLink.actionType === HeaderElementType.ROUTE ? (
                              <Link className="nav-link" aria-current="page" to={headerLink.redirectLink} onClick={closeMobileMenu}>{headerLink.title}</Link>
                            ) : (
                             header.redirectLink === "" ? <span className="dropdown-item">{header.title}</span> :
                              <a className="dropdown-item" href={header.redirectLink} target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
                                {header.title}
                              </a>
                            )}
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : null}
                </li>
              ))}
            </ul>
            <div className="ms-auto d-flex align-items-start flex-column flex-lg-row align-items-lg-center gap-2 gap-lg-0">
              <div className="phone-fax-holder d-flex flex-lg-column gap-2 gap-lg-0">
                <p className="m-0"><i className="bi bi-telephone text-primary"></i> {PHONE_NUMBER}</p>
                <p className="m-0"><i className="bi bi-printer text-primary"></i> {FAX_NUMBER}</p>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default GuestHeader;
